module.exports = __webpack_public_path__ + "static/media/icon_pulldown.bb84e75f.svg";